<template>
  <div class="index">

    <div class="header">
      <tiny-nav-menu :fetch-menu-data="queryHeaderList" :before-skip="handleSkip" prevent>
        <template #logo>
          <router-link to="/" style="display: flex;align-items: center;font-size: 22px;">
            <img src="@/assets/logo.png"
                 alt="logo" style="height: 50px; " class="log_img_width">
            <span style="color: #273154; margin-left: 10px;font-weight: 600;">释格检测</span>
          </router-link>
        </template>
      </tiny-nav-menu>
    </div>

    <transition>
      <router-view />
    </transition>

    <Footer :qrcode="companyInfo.qrcode" :address="companyInfo.address"></Footer>
    <RightMenu></RightMenu>

  </div>
</template>

<script>
import '@/assets/styles/header.css'
import request from '@/utils/request'

import { NavMenu, Carousel, CarouselItem, Image, Floatbar  } from '@opentiny/vue'
import Footer from "@/components/Footer.vue";
import Right from "@/components/Right.vue";

export default {
  name: "index",
  components: {
    Footer,
    RightMenu: Right,
    TinyNavMenu: NavMenu,
    TinyCarousel: Carousel,
    TinyCarouselItem: CarouselItem,
    TinyImage: Image,
    TinyFloatbar: Floatbar
  },
  data() {
    return {
      sourceMenuList: [],
      companyInfo: {
        address: '',
        phone: '',
        fax: '',
        email: '',
        qq: '',
        cnas: '',
        cma: '',
        aqfsq: '',
        zszs: '',
        qrcode: '',
      },
    };
  },

  created() {
    this.queryCompanyInfo();
  },
  mounted() {

  },
  methods: {
    async queryHeaderList() {
      const {data} = await request.get("/outSiteMenu/queryHeaderList")
      this.sourceMenuList = data.data
      console.log(data);
      let headerTree = this.handleTree(data.data, "id", "pid");
      console.log(headerTree, headerTree.length)
      let res = this.recursion(headerTree);
      console.log(res);
      return Promise.resolve(res)
    },

    recursion(list){
      return list.map(x => {
        console.log(x.name)
        // 由于这里不能自定义参数，只能给系统预定的几个参数所以 path 和target 做了替换
        let obj = {id: x.id, title: x.name, url: x.path, target: x.jump};
        if (x.children && x.children.length > 0) {
          obj.children = this.recursion(x.children);
        }
        return obj;
      });
    },

    async queryCompanyInfo() {
      const {data} = await request.get("/outSiteMenu/queryCompanyInfo")
      console.log(data);
      if (data.code === 200 && data.data) {
        this.companyInfo = data.data;
      }
    },


    /**
     *  id,url,jump,name
     * @param row
     */
    handleSkip(row){
      if(row.target === '4' || row.target === '5'){
        window.open(row.url, '_blank');
        return;
      }
      if (row.target === '2') {
        if (row.children && row.children.length > 0 && (row.children[0].target === '1' || row.children[0].target === '3' || row.children[0].target === '4')) {
          row.target = row.children[0].target;
          row.id = row.children[0].id;
        }
      }
      this.$router.push({path: '/page' + row.target , query: {id: row.id}});
    },
  },

};
</script>

<style scoped>

.header{
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 100;
  border-bottom: 1px solid rgba(0,0,0,0.1);
}

</style>
